export default __webpack_public_path__ + "locales/ja-JP/EmptyTrashDialog.json?hash=5ff19129c6f4b098ddd704e7e698c7b3";